export const load = () => ({
	title: 'Claim Submission',
	showTitle: true,

	noindex: true,
});
